// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83609363","455":"0f07fe3f","977":"83884b70"}[chunkId] + ".chunk.js";
};